import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import './dropDownAccumulator.scss';
import { primaryBlue, textColorGray } from 'theme/mainColors';

class DropDownAccumulator extends React.PureComponent {
  state = {
    selectedValue: null
  };

  handleSelectChange = (event, key) => {
    const { value, elementsToShow } = this.props;
    const itemValue = elementsToShow[key].itemValue;
    this.props.profilesActions.updateProfileField(value.length === 0 ? itemValue : `${value}, ${itemValue}`);
  };

  handleTextFieldChange = (event, value) => this.props.profilesActions.updateProfileField(value);

  render() {
    const { selectFieldId, label, name, value, elementsToShow } = this.props;
    return (
      <div className="dropdown-accumulator" >
        <label htmlFor={ name } >{ label }</label>
        <SelectField
          id={ selectFieldId }
          value={ this.state.selectedValue }
          onChange={ this.handleSelectChange }
          underlineStyle={ { borderColor: textColorGray} }
          underlineFocusStyle={ { borderColor: primaryBlue } }
          className="dropdown-accumulator__select-field"
        >
          {
            elementsToShow.map(({itemValue, primaryText}) =>
              <MenuItem key={ itemValue } value={ itemValue } primaryText={ primaryText } />
            )
          }
        </SelectField>
        <ArrowForward
          style={ { marginTop: 14, marginRight: 20 } }
          color="#ccc"
          viewBox="0 0 20 20"
        />
        <TextField
          value={ value }
          name={ name }
          onChange={ this.handleTextFieldChange }
          underlineStyle={ { borderColor: '#555'} }
          underlineFocusStyle={ { borderColor: primaryBlue } }
        />
      </div>
    );
  }
}

DropDownAccumulator.propTypes = {
  selectFieldId: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  elementsToShow: PropTypes.arrayOf(
    PropTypes.shape({
      itemValue: PropTypes.string,
      primaryText: PropTypes.string
    })
  ).isRequired,
  profilesActions: PropTypes.shape({
    updateProfileField: PropTypes.func
  }).isRequired
};

DropDownAccumulator.defaultProps = {
  selectFieldId: 'selectFieldId'
};

export default DropDownAccumulator;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/c/dropDownAccumulator/DropDownAccumulator.js